module.exports = __webpack_public_path__ + "assets/img/0.4ff3bdb3.png";